import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAnderhalveMeter15 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      d="M10.16 23.5a3.97 3.97 0 1 0 0-7.94 3.97 3.97 0 0 0 0 7.94"
    />
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M10.16 23.53a4 4 0 0 0-4 4v6.61h7.93V27.5a4 4 0 0 0-3.93-3.97"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M30.08 23.5a3.97 3.97 0 1 0 0-7.94 3.97 3.97 0 0 0 0 7.94"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M30.08 23.53a4 4 0 0 0-4 4v6.61h7.94V27.5a4 4 0 0 0-3.94-3.97"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22.15 26h10v1h-10zM8.39 26h10v1h-10z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M22.65 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path
      fill="#85BDED"
      d="M17.65 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path
      fill="#0061CD"
      d="m17.33 7.69-1 .58-.55-.89 1.64-1.3h1.16v4.55h-1.25zM19.49 9.07h.82l-.65 1.57h-.52zM20.56 10.22l.44-.86a1.8 1.8 0 0 0 1 .3c.56 0 .78-.24.78-.52s-.37-.47-.87-.47a1.8 1.8 0 0 0-.76.18l-.4-.41V6.08h3v1.11H22v.51q.17-.015.34 0c.82 0 1.71.41 1.71 1.37s-.9 1.65-2 1.65a2.46 2.46 0 0 1-1.49-.5"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M29.83 12.83H10.41v-.5h19.42z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M10.66 10.96h-.5v3.25h.5zM30.08 10.96h-.5v3.25h.5z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAnderhalveMeter15);

export default ForwardRef;
